// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"96":"a4f83e79","141":"205689b0","198":"3e9a4587","253":"a7cc8db0","276":"ce540bd9","324":"9b50218d","354":"0f95be74","411":"e6008819","414":"29fe2833","591":"37a17092","725":"7bd79d54","776":"53efaf1f","826":"5e3d64e0","850":"d595c232"}[chunkId] + ".chunk.js";
};